class ForgottenPassword {
    constructor() {
        this.forgottenPasswordFormValidation();
    }
    forgottenPasswordFormValidation(){
        let form = document.getElementById('frm-resetPasswordForm-forgottenPasswordForm');
        if(form){
            let submitButton = document.getElementById('reset_password_form_submit');
            let passwordMeter = KTPasswordMeter.getInstance(form.querySelector('[data-kt-password-meter="true"]'));
            // Password input validation
            const validatePassword = function() {
                return (passwordMeter.getScore() === 100);
            };

            FormValidation.formValidation(
                form,
                {
                    fields: {
                        'password': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Password has to be between 8 and 45 characters long',
                                },
                                regexp: {
                                    regexp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.])[A-Za-z\d[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.]{8,45}$/,
                                    message: 'You used a forbidden character',
                                },
                                callback: {
                                    message: 'Please enter valid password',
                                    callback: function() {
                                        return validatePassword();
                                    }
                                }
                            }
                        },
                        'confirm_password': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                identical: {
                                    compare: function () {
                                        return form.querySelector('[name="password"]').value;
                                    },
                                    message: 'The password and its confirm are not the same',
                                },
                            },
                        },
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        defaultSubmit: new FormValidation.plugins.DefaultSubmit(), // Uncomment this line to enable normal button submit after form validation
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.fv-row',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        })
                    }
                }
            ).on('core.validator.validated', function (e) {
                if (!e.result.valid) {
                    // Query all messages
                    const messages = [].slice.call(form.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
                    messages.forEach((messageEle) => {
                        const validator = messageEle.getAttribute('data-validator');
                        messageEle.style.display = validator === e.validator ? 'block' : 'none';
                    });
                }
            }).on('core.form.validating', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'on');
                // Disable button to avoid multiple click
                submitButton.disabled = true;
            }).on('core.form.valid', function(e) {
                // Submit form
                form.submit();
            }).on('core.form.invalid', function(event) {
                // Show loading indication
                submitButton.setAttribute('data-kt-indicator', 'off');
                // Disable button to avoid multiple click
                submitButton.disabled = false;
            });
        }
    }
}
window.ForgottenPassword = ForgottenPassword;